module.exports = __webpack_public_path__ + "static/img/ARAD2_2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ARAD2_2.png
// module id = BkQb
// module chunks = 0